import ReportTable from '../../../../../components/Grid/ReportTable';

export default function AgendamentosTable(props: any) {
  return <ReportTable model={props.model} columnCount={8} />;
}
